import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AllQuestions, Question } from "../types/question-type";
// import { ContentViewer } from "./courseStateSliceData.ts";
import { QuestionSubType } from "../types/question-type";

export type DifficultyLevelType = "beginner" | "intermediate" | "advanced";
export type Languages =
  | "en_IN"
  | "en_US"
  | "en_UK"
  | "ja_JP"
  | "uk_UA"
  | "es_ES"
  | "de_DE"
  | "fr_FR"
  | "sv_SE"
  | "ro_RO"
  | "sk_SK"
  | "hr_HR"
  | "pl_PL";
export type Status =
  | "draft"
  | "inreview"
  | "readytopublish"
  | "published"
  | "deleted"
  | "sentback"
  | "all";
export type SourceNames = "WECP" | "internal" | "ai";
// export type QuestionSubType = "mcq" | "scq" | "tf" | "fib" | "all";
export type KnowledgeCategory =
  | "create"
  | "evaluate"
  | "analyze"
  | "understand"
  | "remember"
  | "all";
export type VisibilityType = "public" | "private" | "all";

const INIT_STATE = {
  refetch: false,
  question: {} as Question,
  questionList: [] as AllQuestions[],
  imageURL: "",
  selectedId: "",
  selectedVersion: 1,
  isPreviewFullscreen: false,
  isQuestionCreateFullScreen: false,
  isFirstQuestion: true,
  isReviewRequired: false,
  isFilterOpen: true,
  filtersCount: {
    statusType: false,
    reviewRequired: false,
    sourceNames: false,
    questionType: false,
    kc: false,
    access: true,
    proficiency: false,
    sourceType: false,
    skills: false,
    tags: false,
    maxMarks: false,
    authors: false
  },
  questionFilterCatalog: {
    pageNumber: 0,
    questionFilters: {
      indices: ["question"] as string[],
      title: "" as string,
      problemStatement: "" as string,
      searchTags: {
        defaultTag: [] as string[],
        bloomTaxonomy: [] as KnowledgeCategory[]
      },
      skills: [] as string[],
      sourceType: "",
      sourceNames: [] as SourceNames[],
      sourceName: "",
      languageList: [] as Languages[],
      difficultyLevel: [] as DifficultyLevelType[],
      status: [] as Status[],
      questionSubType: [] as QuestionSubType[],
      access: "all" as string,
      user: [] as string[],
      customVisibility: "allquestion" as string,
      maxMarks: [] as number[],
      exclude: [] as string[],
      reviewRequired: null as boolean | null,
      totalNoOfQuestions: 0 as number,
      authors: [] as string[],
      authorBadge: [] as string[],
      allowedCodingLanguages: [] as string[],
      submissionType: [] as string[]
    }
  },
  selectedQuestion: {} as Question,
  reviewQpFullScreen: false,
  isAllQuestionsChecked: false,
  excludeIds: [] as string[]
};

// const initialState = {
//   pageNumber: 0,
//   questionFilters: {
//     indices: ["question"],
//     title: "",
//     problemStatement: "",
//     searchTags: [],
//     skills: [],
//     sourceType: "",
//     languageList: [],
//     difficultyLevel: [],
//     status: [],
//     questionSubType: [],
//     visibilityType: [],
//   },
// };

const QuestionStateSlice = createSlice({
  name: "QuestionStateSlice",
  initialState: INIT_STATE,
  reducers: {
    setQuestion(state, action: PayloadAction<Question>) {
      return {
        ...state,
        question: action.payload
      };
    },
    setIsPreviewFullscreen(state, action) {
      state.isPreviewFullscreen = action.payload;
    },
    setIsQuestionCreateFullScreen(state, action) {
      state.isQuestionCreateFullScreen = action.payload;
    },
    setPreviewedQuestionType(state, action: PayloadAction<string>) {},
    setIsFirstQuestion(state, action) {
      state.isFirstQuestion = action.payload;
    },
    setIsReviewRequired(state, action) {
      state.isReviewRequired = action.payload;
    },
    setIsFilterOpen(state, action) {
      state.isFilterOpen = action.payload;
    },
    setFiltersCount(state, action) {
      state.filtersCount = action.payload;
    },
    setQuestionList(state, action: PayloadAction<AllQuestions[]>) {
      state.questionList = action.payload;
    },
    setImageURL(state, action) {
      state.imageURL = action.payload;
    },
    setSelectedId(state, action: PayloadAction<string>) {
      state.selectedId = action.payload;
    },
    setSelectedVersion(state, action: PayloadAction<number>) {
      state.selectedVersion = action.payload;
    },
    setNextPage(state) {
      return {
        ...state,
        questionFilterCatalog: {
          ...state.questionFilterCatalog,
          pageNumber: state.questionFilterCatalog?.pageNumber ?? 0
        }
      };
    },
    resetFilters: (state) => {
      return {
        ...state,
        questionFilterCatalog: INIT_STATE.questionFilterCatalog
      };
    },
    questionFilterArgs: (state, action) => {
      return {
        ...state,
        questionFilterCatalog: action?.payload
          ? action.payload
          : state.questionFilterCatalog
      };
    },
    setSelectedQuestion(state, action) {
      state.selectedQuestion = action.payload;
    },
    setRefetch: (state, action: PayloadAction<boolean>) => {
      state.refetch = action.payload;
    },
    setReviewQpFullScreen(state, action) {
      state.reviewQpFullScreen = action.payload;
    },
    setIsAllQuestionsChecked(state, action) {
      state.isAllQuestionsChecked = action.payload;
    },
    setExcludeIds(state, action) {
      state.excludeIds = action.payload;
    }
  }
});

export default QuestionStateSlice;

export const QuestionStateSliceActions = QuestionStateSlice.actions;
